import { useMemo } from 'react';
import useAuthenticatedFetchClient from './UseAuthenticatedFetchClient';
import GqlClient from '@cb/common-ts/GqlClient';
export default function useAuthenticatedGqlClient() {
    const fetchClient = useAuthenticatedFetchClient();
    const gqlClient = useMemo(() => new GqlClient({ endpoint: 'graphql', fetchClient }), [fetchClient]);
    return gqlClient;
}
//# sourceMappingURL=UseAuthenticatedGqlClient.js.map